export type FormMessages = {
	'label.button.ok'?: string;
	'label.hintText.enter'?: string;
	'label.hintText.multipleSelection'?: string;
	'block.dropdown.placeholder'?: string;
	'block.dropdown.noSuggestions'?: string;
	'block.shortText.placeholder'?: string;
	'block.longText.placeholder'?: string;
	'block.longText.hint'?: string;
	'block.number.placeholder'?: string;
	'block.email.placeholder'?: string;
	'block.defaultThankYouScreen.label'?: string;
	'label.hintText.key'?: string;
	'label.yes.default'?: string;
	'label.no.default'?: string;
	'label.progress.percent'?: string;
	'label.errorAlert.required'?: string;
	'label.errorAlert.date'?: string;
	'label.errorAlert.number'?: string;
	'label.errorAlert.selectionRequired'?: string;
	'label.errorAlert.email'?: string;
	'label.errorAlert.url'?: string;
	'label.errorAlert.range'?: string;
	'label.errorAlert.minNum'?: string;
	'label.errorAlert.maxNum'?: string;
	'label.errorAlert.maxCharacters'?: string;
	'label.errorAlert.minChoices'?: string;
	'label.errorAlert.maxChoices'?: string;
	'label.submitBtn'?: string;
	'label.errorAlert.noConnection'?: string;
	'label.errorAlert.serverError'?: string;
	[ x: string ]: string | undefined;
};
